// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__iBOvb","content":"styles_content__7AtwW","image":"styles_image__1NQOI","title":"styles_title__eHNXB","link":"styles_link__q_trk"};